/**
 * Jobs store
 */

import { create } from 'zustand';
import { Job } from '../types/api';

interface JobsState {
  jobs: Job[];
  activeJobs: Set<string>;
  
  setJobs: (jobs: Job[]) => void;
  addJob: (job: Job) => void;
  updateJob: (jobId: string, updates: Partial<Job>) => void;
  markJobActive: (jobId: string) => void;
  markJobComplete: (jobId: string) => void;
}

export const useJobsStore = create<JobsState>((set) => ({
  jobs: [],
  activeJobs: new Set(),
  
  setJobs: (jobs) => set({ jobs }),
  
  addJob: (job) => set((state) => ({
    jobs: [job, ...state.jobs],
    activeJobs: new Set(state.activeJobs).add(job.id),
  })),
  
  updateJob: (jobId, updates) => set((state) => ({
    jobs: state.jobs.map(job => 
      job.id === jobId ? { ...job, ...updates } : job
    ),
  })),
  
  markJobActive: (jobId) => set((state) => ({
    activeJobs: new Set(state.activeJobs).add(jobId),
  })),
  
  markJobComplete: (jobId) => set((state) => {
    const newSet = new Set(state.activeJobs);
    newSet.delete(jobId);
    return { activeJobs: newSet };
  }),
}));


